<template>
  <div>
    <div>
      <p>
        {{ locale.debtorAssets.totalCount }}
        <strong class="totalCount">
          {{ pagination.totalCount ? pagination.totalCount : 0 }}
        </strong>
        {{ locale.debtorAssets.totalSum }}
        <strong class="totalCount">
          {{ totalSum ? totalSum : 0 }}
        </strong>
      </p>
    </div>
    <v-row>
      <v-col>
        <naj-data-table
          no-header
          :headers="headers"
          :loading="loading"
          :items="debtorAssets.list"
          pagination
          :items-per-page="pagination.pageSize"
          :page-index="pagination.pageIndex"
          :server-items-length="pagination.totalCount"
          @update:pageIndex="onPageChange"
        >
          <template slot-scope="{item}">
            <v-icon
              color="primary"
              @click="showModal(item)"
            >
              mdi-eye
            </v-icon>
          </template>
        </naj-data-table>
      </v-col>
    </v-row>
    <naj-modal
      ref="debtorAssetModal"
      :title="`${locale.debtorAssets.debtorAsset}`"
      :width="1200"
      show-footer-close-button
      @onClose="onCloseModal"
    >
      <debtor-asset
        :form-model="formModel"
        :loading="loading"
        :view-mode="viewMode"
      ></debtor-asset>
    </naj-modal>
  </div>
</template>

<script>
import DebtorAsset from './debtor-asset.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('BankruptcyModule');

export default {
  components: { DebtorAsset },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      locale: this.local.bankruptcy.requestDetails,
      formModel: {},
      loading: false,
      viewMode: false,
      debtorAssets: { list: [] },
      totalSum: 0,
      headers: [
        {
          value: 'index',
          text: this.local.bankruptcy.requestDetails.sequence,
        },
        {
          value: 'assetType',
          text: this.local.bankruptcy.requestDetails.debtorAssets.assetType,
        },
        {
          value: 'assetValue',
          text: this.local.bankruptcy.requestDetails.debtorAssets.assetValue,
        },
        {
          value: 'action',
          text: '',
        },
      ],
      pagination: {
        pageSize: 10,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      },
    };
  },
  computed: {},
  mounted() {
    this.pagination.pageIndex = 0;
    this.loadData();
  },
  methods: {
    ...mapActions(['getDebtorAssetsByRequestObjectKey', 'getDebtorAsset']),
    loadData() {
      this.loading = true;
      this.totalSum = 0;
      this.getDebtorAssetsByRequestObjectKey({
        requestObjectKey: this.requestObjectKey,
        ...this.pagination,
      })
        .then(({ data }) => {
          this.loading = false;
          this.debtorAssets = { ...data };
          this.debtorAssets.list.forEach((element, index) => {
            element.index = index + 1 + (this.pagination.pageSize * this.pagination.pageIndex);
          });

          if (this.debtorAssets.list.length)
            this.totalSum = this.debtorAssets.list[0].totalSum;

          this.pagination = {
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages,
            hasPreviousPage: data.hasPreviousPage,
            hasNextPage: data.hasNextPage,
          };
        })
        .finally(() => {
          this.loading = false;
        });

    },
    onPageChange(pageIndex) {
      this.pagination = {
        ...this.pagination,
        pageIndex,
      };
      this.loadData();
    },
    showModal(model) {
      const params = {
        requestObjectKey: this.requestObjectKey,
        objectKey: model.objectKey,
      };
      this.loading = true;
      this.getDebtorAsset(params)
        .then((res) => {
          this.formModel = res.data;
          this.isEditMode = true;
          this.$refs.debtorAssetModal.show();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCloseModal() {
      for (const key in this.formModel)
        if (Object.hasOwnProperty.call(this.formModel, key))
          this.$set(this.formModel, key, undefined);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .info-item-box .info-item-details:nth-child(1) {
  background: var(--app-light-secondary-color) 0% 0% no-repeat padding-box;
}

.totalCount {
  padding: 6px;
  margin-right: 2px;
  margin-left: 13px;
  background-color: black;
  font-size: 13px;
  color: white;
}

div p {
  font-size: 15px;
}
</style>
